// src/utils/date.ts
export function ymd(d: Date): string {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
}

export function parseYmdLocal(ymdStr: string): Date {
    const [y, m, d] = ymdStr.split("-").map(Number);
    return new Date(y, (m ?? 1) - 1, d ?? 1);
}

export function formatTime(d: Date): string {
    return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}